import styled from 'styled-components';

const ItemLink = styled.a`
  ${({ theme }) => theme.fontFamily.secondaryFont.smallRegular}
  color: ${({ theme }) => theme.colors.deep_purple};
  line-height: 24px;
`;

export default ItemLink;
